/*
 * @Author: Claire Cheng
 * @Date: 2023-12-11 18:44:32
 * @LastEditors: Claire Cheng
 * @LastEditTime: 2023-12-26 14:27:55
 * @Description: file content
 */
import { ThemeOptions as MuiThemeOptions, PaletteColor } from '@mui/material';

declare module '@mui/material/styles' {
  interface Theme {
    diseaseGroupsColors?: {
      // NOTE: add colors when updating disease_groups
      // [disease group name]: palette color
      IBD: PaletteColor;
      TCB: PaletteColor;
      'TCB-F': PaletteColor;
      SBS: PaletteColor;
      ALF: PaletteColor;
      RH: PaletteColor;
      RI: PaletteColor;
      RM: PaletteColor;
      PDT: PaletteColor;
      'CRC(VCT・FRU)': PaletteColor;
      NIN: PaletteColor;
      ADC: PaletteColor;
      ALB: PaletteColor;
      CAB: PaletteColor;
      OC: PaletteColor;
      Vaccine: PaletteColor;
    };
  }

  interface ThemeOptions {
    diseaseGroupsColors?: {
      IBD: PaletteColor;
      TCB: PaletteColor;
      'TCB-F': PaletteColor;
      SBS: PaletteColor;
      ALF: PaletteColor;
      RH: PaletteColor;
      RI: PaletteColor;
      RM: PaletteColor;
      PDT: PaletteColor;
      'CRC(VCT・FRU)': PaletteColor;
      NIN: PaletteColor;
      ADC: PaletteColor;
      ALB: PaletteColor;
      CAB: PaletteColor;
      OC: PaletteColor;
      Vaccine: PaletteColor;
    };
  }
}

export const baseThemeOptions: MuiThemeOptions = {
  components: {
    MuiBreadcrumbs: {
      styleOverrides: {
        separator: {
          margin: 0,
        },
      },
    },
    MuiMobileStepper: {
      styleOverrides: {
        // dot: {
        //   backgroundColor: 'transparent',
        // },
        // dotActive: {
        //   backgroundColor: 'transparent',
        // },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          minHeight: 48,
        },
        gutters: {
          '@media (min-width: 600px)': {
            minHeight: 48,
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          lineHeight: 'normal',
        },
      },
    },
    MuiBottomNavigationAction: {
      styleOverrides: {
        label: {
          fontSize: 10,
          fontWeight: 'bold',
          '&.Mui-selected': {
            fontSize: 10,
          },
        },
      },
    },
  },
};
